import { IProposal } from '../../../../../../core/interfaces';
import { Injectable } from '@angular/core';

@Injectable()
export class CopyPasteService {
	public copiedProposal: IProposal;
}
